module.exports = __webpack_public_path__ + "static/media/sofa-2.196b0cea.png";